import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const getDataFromLocalStorage = (key) => {
  try {
    const serializedData = localStorage.getItem(key);
    return serializedData ? JSON.parse(serializedData) : null;
  } catch (error) {
    console.error("Error getting data from localStorage:", error);
    return null;
  }
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const storedUser = getDataFromLocalStorage("userData");

  if (!storedUser) {
    Swal.fire({
      title: "Unauthorized",
      text: "You need to be logged in to access this page.",
      icon: "warning",
      confirmButtonColor: "#00889C",
      confirmButtonText: "Log In Now",
    });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(storedUser.role)) {
    const correctDashboard =
      storedUser.role === "dealer" ? "/dealer/dashboard" : "/profilesetting";

    Swal.fire({
      title: "Access Denied",
      text: "You don't have permission to access this page. Redirecting to your dashboard.",
      icon: "warning",
      confirmButtonColor: "#00889C",
      confirmButtonText: "Go to Dashboard",
    });
    return <Navigate to={correctDashboard} replace />;
  }

  return children;
};

export default ProtectedRoute;
